import SparkMD5 from 'spark-md5'
import { getMessage } from './utils'

export default {
  methods: {
    $md5 (model) {
      return SparkMD5.hash(JSON.stringify(model))
    },
    // 打印
    $print (id, action, method = 'post', model) {
      let form = typeof id === 'string' ? document.getElementById(id) : id
      if (!form) {
        // 创建form对象
        form = document.createElement('form')
        form.id = id
        form.action = action
        form.method = method
        form.target = '_blank'
        document.body.appendChild(form)
      }
      Object.keys(model).forEach(k => {
        let input = form[k]
        if (!input || typeof input !== 'object') { // 当k是一些特殊字符串时，name id之类的 input类型应该是string
            input = document.createElement('input')
            input.type = 'hidden'
            input.name = k
            form.appendChild(input)
        }
        if (model[k] === undefined) {
          input.value = ''
        } else {
          input.value = JSON.stringify(model[k])
        }
      })
      form.submit()
    },
    $getDict (type) {
      if (!type) return
      return new Promise(resolve => {
        this.$api('pub/dict/list', {
          dictType: type
        }).then(res => {
          resolve(res)
        }).catch(err => {
          this.$tips(err, 'error')
        })
      })
    },
    /**
     * 表格空列文本替换
     * @param {*} row 当前行
     * @param {*} column 当前列
     * @param {*} cellValue 当前值
     * @param {*} index 当前索引
     * @param {*} emptyText 为空时显示文本
     */
    $emptyColumn (row, column, cellValue, index, emptyText = '————') {
      if (cellValue === undefined || cellValue === null || cellValue === '' || /^\s+$/.test(cellValue)) {
        return emptyText
      }
      return cellValue
    },
    /**
     * 指定value获取下拉选择框中的label值
     * @param {String} id 
     * @param {Array} list 
     */
    $getLabelByValueFromSelect(value, list = []) {
      if (!value) return ''
      let index = list.findIndex(item => item.id === value)
      if (index !== -1) return list[index].label
      return ''
    },
    $getMessage (data) {
      return getMessage(data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/data-processor.js